import script from "./SendingEmail.vue?vue&type=script&lang=ts&setup=true"
export * from "./SendingEmail.vue?vue&type=script&lang=ts&setup=true"

import "./SendingEmail.vue?vue&type=style&index=0&id=2aa34bea&lang=scss"

const __exports__ = script;

export default __exports__